/* eslint-disable no-console */

import { ReadonlyURLSearchParams } from 'next/navigation';
import {
  OrderData,
  TicketDataParams,
  TicketDataParsed
} from '../../@types/order';
import { brazeService } from 'lib/engagement/braze';

export const parseBrazePurchaseTickets = (
  searchParams: ReadonlyURLSearchParams | null
) => {
  let ticketsParam = searchParams?.get('tickets') ?? '[]';
  if (ticketsParam) ticketsParam = decodeURIComponent(ticketsParam);
  let parsedTickets: TicketDataParams[] = [];
  try {
    parsedTickets = JSON.parse(ticketsParam);
  } catch {
    parsedTickets = [];
  }
  const tickets = parsedTickets;
  const paymentMethod = searchParams?.get('paymentMethod') || '';
  const mapTicket = (ticket: TicketDataParams): TicketDataParsed => ({
    id: ticket.i,
    unitPrice: ticket.p,
    currency: ticket.c,
    quantity: ticket.q
  });
  return {
    tickets: tickets.map(mapTicket),
    paymentMethod
  };
};

export const BRAZE_PURCHASE_TRACKING_KEY =
  'discovery-next.braze.enablelogpurchase';

const BRAZE_TRACK_PURCHASE_KEY = (orderNumber: string) => {
  return `purchaseEventsSent_BRAZE_${orderNumber}`;
};

export const trackPurchaseWithBraze = async (
  orderStatus: string,
  orderData: Pick<OrderData, 'orderNumber' | 'tickets' | 'paymentMethod'>
) => {
  const { orderNumber, tickets, paymentMethod } = orderData;

  if (orderStatus !== 'approved' || !orderNumber || !tickets?.length) {
    return;
  }

  const storageKey = BRAZE_TRACK_PURCHASE_KEY(orderNumber);

  let alreadySent = false;
  try {
    alreadySent = !!sessionStorage.getItem(storageKey);
  } catch (error) {
    console.error('sessionStorage.getItem error:', error);
  }
  if (alreadySent) return;

  try {
    sessionStorage.setItem(storageKey, 'true');
  } catch (error) {
    console.error('sessionStorage.setItem error:', error);
  }

  const purchasePromises = tickets.map((ticket) => {
    const payload = {
      productId: ticket.id,
      price: ticket.unitPrice,
      currency: ticket.currency,
      quantity: ticket.quantity,
      paymentMethod: paymentMethod
    };
    return brazeService.logPurchase(payload);
  });

  try {
    await Promise.all(purchasePromises);
  } catch (error) {
    console.error('Failed to send tracking events:', error);
  }
};
